import { GetWorkspaceTasksQuotaResult } from '@indigohive/cogfy-types/endpoints/getWorkspaceTasksQuota'
import { DrawerCreditsUsage } from '../DrawerCreditsUsage'
import { DrawerTaskQuota } from '../DrawerTaskQuota'
import { Link } from 'react-router-dom'

export type DrawerUsageProps = {
  tasksQuota?: GetWorkspaceTasksQuotaResult
  creditsUsage?: number
  loading?: boolean
  error?: Error | null
  onRefetch?: () => void
}

export function DrawerUsage (props: DrawerUsageProps) {
  const { tasksQuota: workspaceTasksQuota, creditsUsage: workspaceCreditsUsage, loading, error, onRefetch } = props

  return (
    <div className='shadow-[0_-4px_10px_rgba(156,163,175,0.2)]'>
      <div className='flex flex-col gap-2 px-2 py-2'>
        <Link to='./usage/credits'>
          <DrawerCreditsUsage
            creditsUsage={workspaceCreditsUsage}
            loading={loading}
            error={error}
            onRefetch={onRefetch}
          />
        </Link>
        <Link to='./usage/tasks'>
          <DrawerTaskQuota
            tasksQuota={workspaceTasksQuota}
            loading={loading}
            error={error}
            onRefetch={onRefetch}
          />
        </Link>
      </div>
    </div>
  )
}
